<template>
  <div class="main">
    <el-dialog
      :title="$t('lang.openvpn.configuration')"
      :visible.sync="opvDialog"
      center
      width="60%"
    >
      <el-form label-width="160px" :model="opvData" :rules="rules">
        <!-- 启用 -->
        <el-form-item :label="$t('lang.openvpn.enabled')">
          <el-checkbox v-model="opvData.enabled"></el-checkbox>
        </el-form-item>
        <!-- verb 设置输出冗余级别 -->
        <el-form-item :label="$t('lang.openvpn.verb')">
          <el-select size="mini" v-model="opvData.verb" class="form_item">
            <el-option label="-- remove --" value=""></el-option>
            <el-option
              v-for="item in 11"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <p class="part">{{ $t("lang.openvpn.tips1") }}</p>
        </el-form-item>
        <!-- 设备 -->
        <el-form-item :label="$t('lang.openvpn.dev')" v-if="deviceSoftwareVer >= 'v2.5.221125'">
          <el-select size="mini" v-model="opvData.dev" class="form_item">
            <el-option label="tun0" value="tun0"></el-option>
            <el-option label="tap0" value="tap0"></el-option>
          </el-select>
          <p class="part">{{ $t("lang.openvpn.tips24") }}</p>
        </el-form-item>
        <!-- nice 改变进程优先级 -->
        <el-form-item
          :label="$t('lang.openvpn.nice')"
          v-if="showList.includes('nice')"
        >
          <el-input
            size="mini"
            v-model="opvData.nice"
            class="form_item"
            placeholder="0"
          ></el-input>
          <p class="part">{{ $t("lang.openvpn.changeProcessPriority") }}</p>
        </el-form-item>
        <!-- 端口 TCP/UDP 端口 # 同时针对本地和远程 -->
        <el-form-item :label="$t('lang.openvpn.port')" prop="port">
          <el-input
            size="mini"
            v-model="opvData.port"
            class="form_item"
          ></el-input>
          <p class="part">{{ $t("lang.openvpn.tips2") }}</p>
        </el-form-item>
        <!-- dev_type 使用设备类型-->
        <el-form-item
          :label="$t('lang.openvpn.dev_type')"
          v-if="showList.includes('dev_type')"
        >
          <el-select size="mini" v-model="opvData.dev_type" class="form_item">
            <el-option label="-- remove --" value=""></el-option>
            <el-option label="tun" value="tun"></el-option>
            <el-option label="tap" value="tap"></el-option>
          </el-select>
          <p class="part">{{ $t("lang.openvpn.tips4") }}</p>
        </el-form-item>
        <!-- tun_ipv6  使 tun 设备兼容 IPv6-->
        <el-form-item :label="$t('lang.openvpn.tun_ipv6')">
          <el-checkbox v-model="opvData.tun_ipv6"></el-checkbox>
          <p class="part">{{ $t("lang.openvpn.tips3") }}</p>
        </el-form-item>
        <!-- server -->
        <el-form-item
          :label="$t('lang.openvpn.server')"
          v-if="showList.includes('server')"
        >
          <el-input
            size="mini"
            v-model="opvData.server"
            class="form_item"
            placeholder="10.200.200.0 255.255.255.0"
          ></el-input>
          <p class="part">{{ $t("lang.openvpn.tips5") }}</p>
        </el-form-item>
        <!-- server_bridge -->
        <el-form-item
          :label="$t('lang.openvpn.server_bridge')"
          v-if="showList.includes('server_bridge')"
        >
          <el-input
            size="mini"
            v-model="opvData.server_bridge"
            class="form_item"
            placeholder="192.168.1.1 255.255.255.0 192.168.1.128 192.168.1.254"
          ></el-input>
          <p class="part">{{ $t("lang.openvpn.tips6") }}</p>
        </el-form-item>
        <!-- nobind 不绑定本地地址和端口 -->
        <el-form-item :label="$t('lang.openvpn.nobind')">
          <el-checkbox v-model="opvData.nobind"></el-checkbox>
          <p class="part">{{ $t("lang.openvpn.tips7") }}</p>
        </el-form-item>
        <!-- cipher 加密数据包 -->
        <el-form-item :label="$t('lang.openvpn.cipher')" prop="cipher">
          <!-- <el-input
            size="mini"
            v-model="opvData.cipher"
            class="form_item"
          ></el-input> -->
          <el-select size="mini" v-model="opvData.cipher" class="form_item">
            <el-option label="AES-128-CBC" value="AES-128-CBC"></el-option>
            <el-option label="AES-256-CBC" value="AES-256-CBC"></el-option>
            <el-option label="BF-CBC" value="BF-CBC"></el-option>
            <el-option label="DES-EDE3-CBC" value="DES-EDE3-CBC"></el-option>
            <el-option label="自定义" value="custom"></el-option>
          </el-select>
          <p class="part">{{ $t("lang.openvpn.tips8") }}</p>
        </el-form-item>
        <!-- comp_lzo 使用快速 LZO 压缩 -->
        <el-form-item :label="$t('lang.openvpn.comp_lzo')">
          <el-select size="mini" class="form_item" v-model="opvData.comp_lzo">
            <el-option label="-- remove --" value=""></el-option>
            <el-option label="yes" value="yes"></el-option>
            <el-option label="no" value="no"></el-option>
          </el-select>
          <p class="part">{{ $t("lang.openvpn.tips9") }}</p>
        </el-form-item>
        <!-- compress 在 2.4+ 版本上使用压缩选项 -->
        <el-form-item :label="$t('lang.openvpn.compress')" v-if="showList.includes('compress')">
          <el-select size="mini" class="form_item" v-model="opvData.compress">
            <el-option label="-- remove --" value=""></el-option>
            <el-option label="lzo" value="lzo"></el-option>
            <el-option label="lz4" value="lz4"></el-option>
            <el-option label="empty" value="empty"></el-option>
          </el-select>
          <p class="part">{{ $t("lang.openvpn.tips10") }}</p>
        </el-form-item>
        <!-- keepalive 在服务配置模式下简化 Helper 指令 --ping 和 --ping-restart 的表达式 -->
        <el-form-item :label="$t('lang.openvpn.keepalive')" prop="keepalive">
          <el-input
            size="mini"
            v-model="opvData.keepalive"
            class="form_item"
          ></el-input>
          <p class="part">
            {{ $t("lang.openvpn.tips11") }}
          </p>
        </el-form-item>
        <!-- proto 采用协议 -->
        <el-form-item :label="$t('lang.openvpn.proto')">
          <el-select size="mini" class="form_item" v-model="opvData.proto">
            <el-option label="-- remove --" value=""></el-option>
            <el-option label="udp" value="udp"></el-option>
            <el-option label="tcp" value="tcp"></el-option>
          </el-select>
          <p class="part">{{ $t("lang.openvpn.tips12") }}</p>
        </el-form-item>
        <!-- client 配置客户端模式 -->
        <el-form-item :label="$t('lang.openvpn.client')">
          <el-checkbox v-model="opvData.client"></el-checkbox>
          <p class="part">{{ $t("lang.openvpn.tips13") }}</p>
        </el-form-item>
        <!-- remote 远程主机名或 ip 地址 -->
        <el-form-item :label="$t('lang.openvpn.remote')">
          <div class="addGroup" v-for="(item, index) in opvData.remote">
            <el-input
              class="form_item"
              style="width: 320px;"
              v-model="opvData.remote[index]"
              size="mini"
              @input="inputChange(index)"
            ></el-input>
            <el-button
              v-if="index !== opvData.remote.length - 1"
              size="mini"
              type="danger"
              style="margin-left: 20px;width: 30px;height: 24px;padding: 0;"
              @click="removeRemote(index)"
              icon="el-icon-minus"
            ></el-button>
            <el-button
              v-if="index === opvData.remote.length - 1"
              size="mini"
              type="primary"
              style="margin-left: 20px;width: 30px;height: 24px;padding: 0;"
              @click="addRemote"
              icon="el-icon-plus"
            ></el-button>
          </div>
          <p class="part">{{ $t("lang.openvpn.tips14") }}</p>
        </el-form-item>
        <!-- auth_method 认证方式，默认使用 ca 证书认证 -->
        <el-form-item :label="$t('lang.openvpn.auth_method')">
          <el-select
            size="mini"
            class="form_item"
            v-model="opvData.auth_method"
          >
            <el-option
              :label="$t('lang.openvpn.cacert')"
              value="ca cert"
            ></el-option>
            <el-option
              :label="$t('lang.openvpn.username2')"
              value="username"
            ></el-option>
            <el-option
              :label="$t('lang.openvpn.usernameCacert')"
              value="username+ca cert"
            ></el-option>
          </el-select>
          <p class="part">{{ $t("lang.openvpn.tips15") }}</p>
        </el-form-item>
        <!-- username -->
        <el-form-item
          :label="$t('lang.openvpn.username')"
          v-if="
            opvData.auth_method === 'username' ||
              opvData.auth_method === 'username+ca cert'
          "
        >
          <el-input
            size="mini"
            v-model="opvData.username"
            class="form_item"
          ></el-input>
          <p class="part">{{ $t("lang.openvpn.tips16") }}</p>
        </el-form-item>
        <!-- password -->
        <el-form-item
          :label="$t('lang.openvpn.password')"
          v-if="
            opvData.auth_method === 'username' ||
              opvData.auth_method === 'username+ca cert'
          "
        >
          <el-input
            size="mini"
            v-model="opvData.password"
            type="password"
            show-password
            class="form_item"
          ></el-input>
          <p class="part">{{ $t("lang.openvpn.tips16") }}</p>
        </el-form-item>
        <el-form-item :label="$t('lang.openvpn.ca')">
          <div>
            <span v-if="opvData.ca" style="margin-right: 0.625rem;">{{
              opvData.ca
            }}</span>
            <span v-else style="margin-right: 0.625rem;">{{
              content.ca.content
                ? $t("lang.openvpn.selected")
                : $t("lang.openvpn.noFile")
            }}</span>
            <el-button type="primary" size="mini">
              <label for="ca">
                <input
                  type="file"
                  v-show="false"
                  id="ca"
                  @input="fileUpdate($event, 'ca')"
                />
                {{ $t("lang.openvpn.tips17") }}
              </label>
            </el-button>
            <p v-if="fileNameList.ca.file_name">
              {{ $t("lang.openvpn.tips19") }}{{ fileNameList.ca.file_name }}
            </p>
          </div>
          <p class="part">{{ $t("lang.openvpn.tips18") }}</p>
        </el-form-item>
        <el-form-item
          :label="$t('lang.openvpn.cert')"
          v-if="
            opvData.auth_method === 'ca cert' ||
              opvData.auth_method === 'username+ca cert'
          "
        >
          <div>
            <span v-if="opvData.cert" style="margin-right: 0.625rem;">{{
              opvData.cert
            }}</span>
            <span v-else style="margin-right: 0.625rem;">{{
              content.cert.content
                ? $t("lang.openvpn.selected")
                : $t("lang.openvpn.noFile")
            }}</span>
            <el-button type="primary" size="mini">
              <label for="cert">
                <input
                  type="file"
                  v-show="false"
                  id="cert"
                  @input="fileUpdate($event, 'cert')"
                />
                {{ $t("lang.openvpn.tips17") }}
              </label>
            </el-button>
            <p v-if="fileNameList.cert.file_name">
              {{ $t("lang.openvpn.tips19") }}{{ fileNameList.cert.file_name }}
            </p>
          </div>
          <p class="part">{{ $t("lang.openvpn.tips19") }}</p>
        </el-form-item>
        <el-form-item
          :label="$t('lang.openvpn.key')"
          v-if="
            opvData.auth_method === 'ca cert' ||
              opvData.auth_method === 'username+ca cert'
          "
        >
          <div>
            <span v-if="opvData.key" style="margin-right: 0.625rem;">{{
              opvData.key
            }}</span>
            <span v-else style="margin-right: 0.625rem;">{{
              content.key.content
                ? $t("lang.openvpn.selected")
                : $t("lang.openvpn.noFile")
            }}</span>
            <el-button type="primary" size="mini">
              <label for="key">
                <input
                  type="file"
                  v-show="false"
                  id="key"
                  @input="fileUpdate($event, 'key')"
                />
                {{ $t("lang.openvpn.tips17") }}
              </label>
            </el-button>
            <p v-if="fileNameList.key.file_name">
              {{ $t("lang.openvpn.tips19") }}{{ fileNameList.key.file_name }}
            </p>
          </div>
          <p class="part">{{ $t("lang.openvpn.tips22") }}</p>
        </el-form-item>
        <!-- 使用静态密钥 -->
        <el-form-item :label="$t('lang.openvpn.useStaticKeys')">
          <el-checkbox
            v-model="opvData.enable_secret"
            @change="changeUseStaticKey"
          ></el-checkbox>
        </el-form-item>
        <el-form-item :label="$t('lang.openvpn.secret')" v-if="secretShow">
          <div>
            <span v-if="opvData.secret" style="margin-right: 0.625rem;">{{
              opvData.secret
            }}</span>
            <span v-else style="margin-right: 0.625rem;">{{
              content.secret.content
                ? $t("lang.openvpn.selected")
                : $t("lang.openvpn.noFile")
            }}</span>
            <el-button type="primary" size="mini">
              <label for="secret">
                <input
                  type="file"
                  v-show="false"
                  id="secret"
                  @input="fileUpdate($event, 'secret')"
                />
                {{ $t("lang.openvpn.tips17") }}
              </label>
            </el-button>
          </div>
          <p class="part">{{ $t("lang.openvpn.tips18") }}</p>
        </el-form-item>
        <!-- 使用TLS-认证 -->
        <el-form-item
          :label="$t('lang.openvpn.enabletlsauth')"
          v-if="deviceSoftwareVer >= 'v2.5.221125'"
        >
          <el-checkbox
            v-model="opvData.enable_tlsauth"
            @change="changeUseTlsAuth"
          ></el-checkbox>
          <p class="part">{{ $t("lang.openvpn.addtlsauth") }}</p>
        </el-form-item>
        <el-form-item :label="$t('lang.openvpn.tlsAuth')" v-if="tlsAuthShow">
          <div>
            <span v-if="opvData.secret" style="margin-right: 0.625rem;">{{
              opvData.secret
            }}</span>
            <span v-else style="margin-right: 0.625rem;">{{
              content.secret.content
                ? $t("lang.openvpn.selected")
                : $t("lang.openvpn.noFile")
            }}</span>
            <el-button type="primary" size="mini">
              <label for="secret">
                <input
                  type="file"
                  v-show="false"
                  id="secret"
                  @input="fileUpdate($event, 'tls-auth')"
                />
                {{ $t("lang.openvpn.tips17") }}
              </label>
            </el-button>
          </div>
          <p class="part">{{ $t("lang.openvpn.tips18") }}</p>
        </el-form-item>
        <!-- 使用TLS-共享密钥 -->
        <el-form-item
          :label="$t('lang.openvpn.enabletlscrypt')"
          v-if="deviceSoftwareVer >= 'v2.5.221125'"
        >
          <el-checkbox
            v-model="opvData.enable_tls_crypt"
            @change="changeUseTlsAuth"
          ></el-checkbox>
          <p class="part">{{ $t("lang.openvpn.addtlscrypt") }}</p>
        </el-form-item>
        <el-form-item
          :label="$t('lang.openvpn.tls_crypt')"
          v-if="
            deviceSoftwareVer >= 'v2.5.221125'
              ? useTlsCryptShow
              : showList.includes('tls_crypt')
          "
        >
          <div>
            <span v-if="opvData.tls_crypt" style="margin-right: 0.625rem;">{{
              opvData.tls_crypt
            }}</span>
            <span v-else style="margin-right: 0.625rem;">{{
              content.tls_crypt.content
                ? $t("lang.openvpn.selected")
                : $t("lang.openvpn.noFile")
            }}</span>
            <el-button type="primary" size="mini">
              <label for="tls_crypt">
                <input
                  type="file"
                  v-show="false"
                  id="tls_crypt"
                  @input="fileUpdate($event, 'tls_crypt')"
                />
                {{ $t("lang.openvpn.tips17") }}
              </label>
            </el-button>
            <p v-if="fileNameList.tls_crypt.file_name">
              {{ $t("lang.openvpn.tips19")
              }}{{ fileNameList.tls_crypt.file_name }}
            </p>
          </div>
          <p class="part">{{ $t("lang.openvpn.tips23") }}</p>
        </el-form-item>
        <!-- 使用DH协议文件 -->
        <el-form-item
          :label="$t('lang.openvpn.enableDh')"
          v-if="deviceSoftwareVer >= 'v2.5.221125'"
        >
          <el-checkbox
            v-model="opvData.enable_dh"
            @change="changeUseDh"
          ></el-checkbox>
          <p class="part">{{ $t("lang.openvpn.addDh") }}</p>
        </el-form-item>
        <el-form-item
          :label="$t('lang.openvpn.dh')"
          v-if="
            deviceSoftwareVer >= 'v2.5.221125'
              ? usdDhShow
              : showList.includes('dh')
          "
        >
          <div>
            <span v-if="opvData.dh" style="margin-right: 0.625rem;">{{
              opvData.dh
            }}</span>
            <span v-else style="margin-right: 0.625rem;">{{
              content.dh.content
                ? $t("lang.openvpn.selected")
                : $t("lang.openvpn.noFile")
            }}</span>
            <el-button type="primary" size="mini">
              <label for="dh">
                <input
                  type="file"
                  v-show="false"
                  id="dh"
                  @input="fileUpdate($event, 'dh')"
                />
                {{ $t("lang.openvpn.tips17") }}
              </label>
            </el-button>
            <p v-if="fileNameList.dh.file_name">
              {{ $t("lang.openvpn.tips19") }}{{ fileNameList.dh.file_name }}
            </p>
          </div>
          <p class="part">{{ $t("lang.openvpn.tips21") }}</p>
        </el-form-item>
        <!-- 使用pkcs#12文件 -->
        <el-form-item
          :label="$t('lang.openvpn.enablePkcs')"
          v-if="deviceSoftwareVer >= 'v2.5.221125'"
        >
          <el-checkbox
            v-model="opvData.enable_pkcs12"
            @change="changeUsePkcs"
          ></el-checkbox>
          <p class="part">{{ $t("lang.openvpn.addPkcs") }}</p>
        </el-form-item>
        <el-form-item
          :label="$t('lang.openvpn.pkcs12')"
          v-if="
            deviceSoftwareVer >= 'v2.5.221125'
              ? usePkcsShow
              : showList.includes('pkcs12')
          "
        >
          <div>
            <span v-if="opvData.secret" style="margin-right: 0.625rem;">{{
              opvData.pkcs12
            }}</span>
            <span v-else style="margin-right: 0.625rem;">{{
              content.pkcs12.content
                ? $t("lang.openvpn.selected")
                : $t("lang.openvpn.noFile")
            }}</span>
            <el-button type="primary" size="mini">
              <label for="pkcs12">
                <input
                  type="file"
                  v-show="false"
                  id="pkcs12"
                  @input="fileUpdate($event, 'pkcs12')"
                />
                {{ $t("lang.openvpn.tips17") }}
              </label>
            </el-button>
            <p v-if="fileNameList.pkcs12.file_name">
              {{ $t("lang.openvpn.tips19") }}{{ fileNameList.pkcs12.file_name }}
            </p>
          </div>
          <p class="part">{{ $t("lang.openvpn.tips20") }}</p>
        </el-form-item>
        <el-form-item
          :label="$t('lang.openvpn.authParameter')"
          v-if="showList.includes('auth')"
        >
          <el-input
            v-if="authInputShow"
            v-model="authValue"
            size="mini"
            class="form_item"
            @change="changeAuthValue"
          ></el-input>
          <el-select
            v-model="opvData.auth"
            placeholder="请选择"
            style="width: 100%"
            size="mini"
            class="form_item"
            @change="authChange"
            v-else
          >
            <el-option
              v-for="item in authList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <div>
        <el-select size="mini" v-model="more">
          <el-option
            :label="$t('lang.openvpn.moreSelect')"
            value=""
          ></el-option>
          <el-option
            :label="moreListObj[item]"
            :value="item"
            v-for="(item, index) in moreList"
            :key="index"
          ></el-option>
        </el-select>
        <el-button
          size="mini"
          type="primary"
          style="margin-left: 20px;"
          @click="addOptions"
          >{{ $t("lang.openvpn.addSelect") }}</el-button
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">{{
          $t("lang.openvpn.saveEdit")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "opv",
  props: ["opvData", "deviceSoftwareVer"],
  data() {
    return {
      opvDialog: false,
      more: "",
      moreList: ["nice", "dev_type", "server", "server_bridge", "compress"],
      moreListObj: {
        nice: this.$t('lang.openvpn.nice'),
        dev_type: this.$t('lang.openvpn.dev_type'),
        server: this.$t('lang.openvpn.server'),
        server_bridge: this.$t('lang.openvpn.server_bridge'),
        compress: this.$t('lang.openvpn.compress'),
        auth: this.$t('lang.openvpn.auth'),
        tls_crypt:this.$t('lang.openvpn.tls_crypt'),
      },
      showList: [],
      content: {
        ca: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.ca",
          content: "",
        },
        key: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.key",
          content: "",
        },
        cert: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.cert",
          content: "",
        },
        secret: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.secret",
          content: "",
        },
        pkcs12: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.pkcs12",
          content: "",
        },
        dh: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.dh",
          content: "",
        },
        tls_crypt: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.tls_crypt",
          content: "",
        },
      },
      fileNameList: {
        ca: {
          file_name: "",
        },
        key: {
          file_name: "",
        },
        cert: {
          file_name: "",
        },
        secret: {
          file_name: "",
        },
        pkcs12: {
          file_name: "",
        },
        dh: {
          file_name: "",
        },
        tls_crypt: {
          file_name: "",
        },
      },
      rules: {
        port: [{ required: true, message: "请输入端口", trigger: "blur" }],
        cipher: [
          { required: true, message: "请输入加密数据包", trigger: "blur" },
        ],
        keepalive: [{ required: true, message: "请输入值", trigger: "blur" }],
      },
      authList: [
        {
          label: "---移除---",
          value: "",
        },
        {
          label: "SHA256",
          value: "SHA256",
        },
        {
          label: "---自定义---",
          value: "custom",
        },
      ],
      secretShow: false,
      authInputShow: false,
      authValue: "",
      tlsAuthShow: false,
      usdDhShow: false,
      usePkcsShow: false,
      useTlsCryptShow: false,
    };
  },
  methods: {
    removeRemote(e) {
      this.opvData.remote = this.opvData.remote.filter(
        (v, index) => index != e
      );
    },
    fileUpdate(e, name) {
      let file = e.target.files[0];
      let txt = new FileReader();
      txt.readAsText(file, "UTF-8");
      txt.onload = () => {
        this.content[name].content = txt.result;
        this.fileNameList[name].file_name = file.name;
        this.$message({
          message: "本地文件上传成功",
          type: "success",
        });
      };
    },
    confirm() {
      this.opvDialog = false;
      this.$emit("update", this.content, this.opvData);
    },
    addRemote() {
      if (this.opvData.remote[this.opvData.remote.length - 1]) {
        this.opvData.remote.push("");
      }
    },
    addOptions() {
      this.moreList = this.moreList.filter((v) => v != this.more);
      this.showList.push(this.more);
      this.more = "";
    },
    inputChange(e) {
      console.log(this.opvData.remote[e]);
    },
    changeUseStaticKey() {
      this.secretShow = !this.secretShow;
    },
    authChange() {
      if (this.opvData.auth == "custom") {
        this.authValue = "";
        this.authInputShow = true;
      }
    },
    changeAuthValue() {
      if (this.authList.find((v) => v.label == this.authValue)) {
        this.opvData.auth = this.authValue;
        this.authInputShow = false;
      } else {
        this.authList.push({
          label: this.authValue,
          value: this.authValue,
        });
        this.opvData.auth = this.authValue;
        this.authInputShow = false;
      }
    },
    changeUseTlsAuth() {
      this.tlsAuthShow = !this.tlsAuthShow;
    },
    changeUseDh() {
      this.usdDhShow = !this.usdDhShow;
    },
    changeUsePkcs() {
      this.usePkcsShow = !this.usePkcsShow;
    },
    changeUseTlsCrypt() {
      this.useTlsCryptShow = !this.useTlsCryptShow;
    },
  },
  created() {
    if (this.deviceSoftwareVer >= "v2.5.221125") {
      this.moreList.push("auth");
      this.moreList.push("tls_crypt");
      this.moreList.push("dh");
      this.moreList.push("pkcs12");
    }
  },
};
</script>
<style scoped>
.form_item {
  width: 100%;
}
.part {
  display: block;
  height: 20px;
  color: #bbbbbd;
  font-size: 14px;
  line-height: 20px;
}
.main /deep/ .el-form-item {
  margin-bottom: 12px;
}
.addGroup {
  display: flex;
  align-items: center;
}
</style>
